module.exports = __webpack_public_path__ + "img/L_9H.51d55e17.png";